import { useQuery } from "@apollo/client/react";
import GET_CLIENTS_WITH_INVOICES from "../../queries/invoices/getClientsWithInvoices";
import type { ClientsWithInvoicesModel } from "../../../models/ClientsWithInvoicesModel";
import type { InvoiceProcessStatus } from "../../../models/InvoiceStatusModel";

export const useClientStatusCounts = (clientIdentifier: string | undefined) => {
  const { data, loading } = useQuery<{
    clientsWithInvoices: ClientsWithInvoicesModel;
  }>(GET_CLIENTS_WITH_INVOICES, {
    variables: { clientIdentifier, skip: 0, take: 1 },
    skip: !clientIdentifier,
  });

  const match = data?.clientsWithInvoices.items.find(
    (item) => item.client?.identifier === clientIdentifier || item.client?.id === clientIdentifier,
  );

  return {
    statusCounts: match?.statusCounts ?? ([] as Array<{ status: InvoiceProcessStatus; count: number }>),
    unhandledDocumentCount: match?.unhandledDocumentCount ?? 0,
    loading,
  };
};
